export enum VehicleMappingType {
  ALLIANZ = "ALLIANZ",
  COLONNADE = "COLONNADE",
  CSOB_MTPL = "CSOB_MTPL",
  CSOB_CRASH = "CSOB_CRASH",
  DEFEND = "DEFEND",
  GENERALI = "GENERALI",
  KOMUNALNA = "KOMUNALNA",
  KOOPERATIVA = "KOOPERATIVA",
  PILLOW = "PILLOW",
  UNION = "UNION",
  UNIQA = "UNIQA",
}

export const VehicleMappingTypeKeys = {
  [VehicleMappingType.ALLIANZ]: "allianz",
  [VehicleMappingType.COLONNADE]: "colonnade",
  [VehicleMappingType.CSOB_MTPL]: "csobMtpl",
  [VehicleMappingType.CSOB_CRASH]: "csobCrash",
  [VehicleMappingType.DEFEND]: "defend",
  [VehicleMappingType.GENERALI]: "generali",
  [VehicleMappingType.KOMUNALNA]: "komunalna",
  [VehicleMappingType.KOOPERATIVA]: "kooperativa",
  [VehicleMappingType.PILLOW]: "pillow",
  [VehicleMappingType.UNION]: "union",
  [VehicleMappingType.UNIQA]: "uniqa",
} as const satisfies Record<VehicleMappingType, string>;

export type VehicleMappingTypeKey = (typeof VehicleMappingTypeKeys)[VehicleMappingType];
